import { useAuth } from "../../Contexts/AuthContext";
import { ApiClient } from "../../Services/api";

export default function useAxios() {
  const { isLoggedIn, logout } = useAuth();
  ApiClient.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response) {
        const { status, data } = error.response;
        console.log({
          status,
          data,
        });
        // 401, 403
        // console.error(`API Error [${status}]:`, data);
        switch (status) {
          case 401:
            console.warn("Unauthorized — redirect to login");
            if (isLoggedIn) logout();
            // logoutUser();
            break;
          case 403:
            console.warn("Forbidden");
            break;
          // case 400:
          //   console.warn("Bad Request:", data);
          //   break;
          // case 404:
          //   console.warn("Resource Not Found");
          //   break;
          // case 500:
          //   console.error("Server Error:", data);
          //   break;
          default:
            console.error("Unhandled API error:", data);
        }
      } else if (error.request) {
        //       console.error('Network Error:', error.request);
        console.error("No response received:", error.request);
      } else {
        console.error("Request setup error:", error.message);
      }
      // use throw to get to the code that called the API.
      return Promise.reject(error);
    }
  );
}
